import { renderTemplatePDFs } from '@sellsuki-org/sellsuki-paper-template-renderer'
import taxAgentTemplate from './tax-agent.json'

export default async function (data) {
  const pdfByte = await renderTemplatePDFs(taxAgentTemplate, [data])
  const url = window.URL.createObjectURL(
    new Blob([new Uint8Array(pdfByte)], { type: 'application/pdf' })
  )
  const link = document.createElement('a')
  link.href = url
  link.download = 'tax-agent.pdf'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
